<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :custom="['header', 'footer']"
        :submit="handleSubmitFormCompany"
        @close="closeOverSide">
        <template #header>
            <div class="hts-settings-user-group-ignore-add-user">
                <div class="hts-settings-user-group-ignore-add-user__container-header">
                    <h3 class="title">
                        <hi-plus-circle-icon class="icon" />
                        <span class="label">
                            {{ $t('labels.addNewCompany') }}
                        </span>
                    </h3>
                    <button
                        class="button_close"
                        @click="closeOverSide">
                        <hi-x-icon
                            class="h-6 w-6"
                            aria-hidden="true" />
                    </button>
                </div>
            </div>
        </template>

        <template #body>
            <div class="hts-settings-user-group-ignore-add-user">
                <div class="hts-settings-user-group-ignore-add-user__container-body">
                    <!--        <hts-form> -->
                    <h3 class="title">
                        <hi-rewind-icon class="icon overturned" />
                        <span class="label">
                            {{ $t('labels.generalInformation') }}
                        </span>
                    </h3>
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="formData.companyName"
                            :label="$t('labels.companyName')"
                            :required="true"
                            :color="props.color"
                            name="companyName" />
                        <hts-form-input
                            v-model="formData.email"
                            :label="$t('labels.emailAddress')"
                            :required="true"
                            :color="props.color"
                            name="email" />
                        <hts-form-input
                            v-model="formData.address"
                            :label="$t('labels.address')"
                            :required="true"
                            :color="props.color"
                            name="address" />
                        <hts-form-input
                            v-model="formData.fax"
                            :label="$t('labels.fax')"
                            :required="true"
                            :color="props.color"
                            name="fax" />
                        <hts-form-input
                            v-model="formData.website"
                            :label="$t('labels.website')"
                            :required="true"
                            :color="props.color"
                            name="website" />
                        <hts-form-input
                            v-model="formData.phone"
                            :label="$t('labels.phone')"
                            :required="true"
                            :color="props.color"
                            name="phone" />
                        <hts-form-input
                            v-model="formData.taxNumber"
                            :label="$t('labels.taxNumber')"
                            :required="true"
                            :color="props.color"
                            name="phone" />
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="hts-settings-user-group-ignore-add-user">
                <div class="hts-settings-user-group-ignore-add-user__container-footer">
                    <div class="footer">
                        <div class="footer-left">
                            <hts-form-button
                                icon-name="hi-save-icon"
                                icon-position="right"
                                color="info"
                                type="submit">
                                {{ $t('labels.save') }}
                            </hts-form-button>

                            <hts-form-button
                                color="white"
                                icon-name="hi-x-icon"
                                icon-position="right"
                                :disabled="true"
                                @click="closeOverSide">
                                {{ $t('labels.cancel') }}
                            </hts-form-button>
                        </div>

                        <div>
                            <hts-form-button
                                type="text"
                                color="error"
                                icon-name="hi-refresh-icon"
                                icon-position="right"
                                @click="resetForm()">
                                {{ $t('labels.undo') }}
                            </hts-form-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'x-large'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['close'])

const closeOverSide = () => {
  emits('close')
}

// const listInput = ref([{ key: 1 }])

// const addGroupInput = () => {
//   const item: { key: number } | undefined = useLast(listInput.value)
//   listInput.value = [...listInput.value, { key: (item?.key || 0) + 1 }]
// }

// const deleteGroupInput = (key: number) => {
//   listInput.value = useFilter(listInput.value, value => value.key !== key)
// }

const initForm = {
  companyName: '',
  email: '',
  address: '',
  website: '',
  phone: '',
  fax: '',
  taxNumber: ''
}

const formData = reactive({ ...initForm })
const resetForm = () => {
  Object.assign(formData, initForm)
}

const handleSubmitFormCompany = $lodash.debounce(async () => {
  const accessToken = useCookie('AUTH_ACCESS_TOKEN', { default: () => '' })
  const api = {
    url: '/company',
    method: 'post',
    headers: {
      Authorization: 'Bearer ' + accessToken.value,
      'hts-workspace': '62f9bbe7adcfab73d748fd92'
    }
  }
  const dataForm = {
    email: $lodash.get(formData, 'email', ''),
    name: $lodash.get(formData, 'companyName', ''),
    address: $lodash.get(formData, 'address', ''),
    website: $lodash.get(formData, 'website', ''),
    phone: $lodash.get(formData, 'phone', ''),
    fax: $lodash.get(formData, 'fax', ''),
    taxNumber: $lodash.get(formData, 'taxNumber', ''),
    status: 'active',
    code: $lodash.get(formData, 'companyName', '')
  }
  const res = await $api(api, { body: new URLSearchParams(dataForm) })
  if (!res) {
    return false
  }
  const data: any = res.data.value
  const error: any = res.error

  if (data) {
    if (process.client) {
      $toast().success('Thêm thành công')
    }
    location.reload()
    resetForm()
  }
  if (error) {
    if (error.value.data === undefined) {
      $toast().error('Không thể kết nối tới máy chủ')
    }
    if (error.value.data !== undefined) {
      $toast().error(error.value.data.errors[0])
    }
  }
}, 500)
// const sizeItemInputDefault = ['mini', 'small', 'default', 'large', 'x-large', 'full']
// const sizeSlideOverDefault = ['mini', 'small', 'default', 'large', 'x-large', 'screen-sm', 'screen-md', 'screen-lg', 'screen-xl', 'screen-2xl']
// const colorDefault = ['active', 'info', 'success', 'error', 'warning', 'disable', 'default']

// const cClass = computed(() => {
//   return {
//     [colorClass.value]: true,
//     [sizeSlideOverClass.value]: true,
//     [sizeItemInputClass.value]: true
//   }
// })

// const colorClass = computed(() => {
//   if (useIncludes(colorDefault, props.color)) {
//     return `color-${props.color}`
//   }
//   return 'color-default'
// })

// const sizeSlideOverClass = computed(() => {
//   if (useIncludes(sizeSlideOverDefault, props.sizeSlideOver)) {
//     return `size-slide-over-${props.sizeSlideOver}`
//   }
//   return 'size-slide-over-default'
// })

// const sizeItemInputClass = computed(() => {
//   if (useIncludes(sizeItemInputDefault, props.sizeItemInput)) {
//     return `size-input-${props.sizeItemInput}`
//   }
//   return 'size-input-default'
// })

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})
</script>
